export class EffectivenessTaskCounts {
    populationSize: number;
    completed: number;
    notCompleted: number;
}
